import { Inject, Pipe, PipeTransform } from '@angular/core';
import { APP_CONFIG_OFERTAS, IAppOfertas } from '../../app.config/app.config-ofertas';

@Pipe({
  name: 'estadosPipe'
})
export class EstadosPipe implements PipeTransform {

    constructor(
        @Inject(APP_CONFIG_OFERTAS) private iAppOfertas: IAppOfertas,
    ){}

    transform( stateNums: number ): string {

        switch (stateNums) {

            case this.iAppOfertas.estado_0.number:
                return this.iAppOfertas.estado_0.name;

            case this.iAppOfertas.estado_1.number:
                return this.iAppOfertas.estado_1.name;

            case this.iAppOfertas.estado_2.number:
                return this.iAppOfertas.estado_2.name;

            case this.iAppOfertas.estado_3.number:
                return this.iAppOfertas.estado_3.name;

            case this.iAppOfertas.estado_4.number:
                return this.iAppOfertas.estado_4.name; 

            case this.iAppOfertas.estado_5.number:
                return this.iAppOfertas.estado_5.name;

            case this.iAppOfertas.estado_6.number:
                return this.iAppOfertas.estado_6.name;

            case this.iAppOfertas.estado_14.number:
                return this.iAppOfertas.estado_14.name;

            case this.iAppOfertas.estado_15.number:
                return this.iAppOfertas.estado_15.name;

            case this.iAppOfertas.estado_16.number:
                return this.iAppOfertas.estado_16.name;

            // case this.iAppOfertas.estado_7.number:
            //     return this.iAppOfertas.estado_7.name;    

            // case this.iAppOfertas.estado_8.number:
            //     return this.iAppOfertas.estado_8.name;    

            // case this.iAppOfertas.estado_9.number:
            //     return this.iAppOfertas.estado_9.name;   

            // case this.iAppOfertas.estado_9.number:
            //     return this.iAppOfertas.estado_9.name;    

            default:
                return 'NOT DESCRIPTION';
               
        }



    }

}
